import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "text-xs"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = {
  key: 1,
  class: "text-xs"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { key: 1 }

import { shortLocaleString } from "@/helpers/datehelper";
import {
  nameFromUid,
  profileFromUid,
} from "@/helpers/requestHelpers/publicDataRequests";
import DialogCard from "@/components/DialogCard.vue";
import { ref, onMounted, watch } from "vue";
import { Profile } from "@/interfaces/profile";
import { ManagedPatientDataPoint } from "@/interfaces/managedPatient";
import { useManagedPatientsStore } from "@/store/managedPatientsStore";
import { Medication } from "@/interfaces/medication";
import ChangelogEntry from "@/components/ChangelogEntry.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

interface ChangeRecordMedication {
  property: string;
  from?: Medication;
  to?: Medication;
  by?: Profile;
  byName: string;
  time: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MedicationHistory',
  props: {
    ofUser: {},
    files: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const history = ref<ManagedPatientDataPoint[] | null>(null);

watch(
  () => props.ofUser,
  () => {
    changelog();
  }
);

onMounted(() => {
  changelog();

  window._paq.push(["trackEvent", "MedicationHistory", "opened", undefined]);
});

async function changelog() {
  history.value = null;
  if (props.ofUser == null) {
    return;
  }
  history.value =
    await useManagedPatientsStore().loadPatientMedicationHistoryOf(
      props.ofUser
    );
}

function findChangesOverTime(
  datapoints: ManagedPatientDataPoint[]
): ChangeRecordMedication[] {
  const changeRecords: ChangeRecordMedication[] = [];

  for (let i = 1; i < datapoints.length; i++) {
    const previousEntry = datapoints[i - 1].decrypted_data as
      | Medication[]
      | null;
    const currentEntry = datapoints[i].decrypted_data as Medication[] | null;
    if (currentEntry == null) continue;

    for (const medication of currentEntry) {
      const previousMedication = previousEntry?.find(
        (prevMedication: Medication) =>
          prevMedication.createdAt == medication.createdAt
      );

      if (
        previousMedication?.gtin != medication.gtin ||
        previousMedication?.file != medication.file ||
        previousMedication?.dscrd != medication.dscrd
      ) {
        changeRecords.push({
          property: "medication",
          from: previousMedication,
          to: medication,
          by: profileFromUid(datapoints[i].created_by) ?? undefined,
          byName: nameFromUid(datapoints[i].created_by),
          time: datapoints[i].created_at,
        });
      }
    }
    if (previousEntry) {
      for (const medication of previousEntry) {
        const medicationStillExists =
          currentEntry?.find(
            (currentMedication: Medication) =>
              currentMedication.createdAt == medication.createdAt
          ) != undefined;

        if (!medicationStillExists) {
          changeRecords.push({
            property: "medication",
            from: medication,
            to: undefined,
            by: profileFromUid(datapoints[i].created_by) ?? undefined,
            byName: nameFromUid(datapoints[i].created_by),
            time: datapoints[i].created_at,
          });
        }
      }
    }
  }
  return changeRecords;
}

function documentNameWithPath(path: string) {
  return props.files.find((file) => file.file_path == path)?.decrypted_data
    .fileName;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogCard, {
    "show-footer": false,
    title: "Änderungsverlauf",
    "is-visible": props.ofUser != null,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emits('close')))
  }, {
    default: _withCtx(() => [
      (history.value == null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(LoadingSpinner)
          ]))
        : (history.value.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Keine Einträge"))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(findChangesOverTime(history.value).reverse(), (change) => {
              return (_openBlock(), _createBlock(ChangelogEntry, {
                key: `${change.by}${change.time}`,
                class: "w-full table-fixed",
                "change-by": change.by ?? null,
                "change-text": null,
                "always-row": true,
                "change-time": _unref(shortLocaleString)(change.time)
              }, {
                from: _withCtx(() => [
                  (change.from)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createTextVNode(_toDisplayString(change.from.dscrd) + " ", 1),
                        (change.from.gtin && change.from.gtin != 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                              _hoisted_5,
                              _createTextVNode(_toDisplayString(change.from.gtin), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (change.from.file && change.from.file != null)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                              _hoisted_7,
                              _createTextVNode(_toDisplayString(documentNameWithPath(change.from.file)), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_8, "Neue Medikation"))
                ]),
                to: _withCtx(() => [
                  (change.to)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createTextVNode(_toDisplayString(change.to.dscrd), 1),
                        (change.to.gtin && change.to.gtin != 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                              _hoisted_11,
                              _createTextVNode(_toDisplayString(change.to.gtin), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (change.to.file && change.to.file != null)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                              _hoisted_13,
                              _createTextVNode(_toDisplayString(documentNameWithPath(change.to.file)), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_14, "Medikation gelöscht"))
                ]),
                _: 2
              }, 1032, ["change-by", "change-time"]))
            }), 128)),
      (history.value && history.value.length > 0)
        ? (_openBlock(), _createBlock(ChangelogEntry, {
            key: 3,
            "change-by": _unref(profileFromUid)(history.value[0].created_by) ?? null,
            "change-text": "",
            "change-time": _unref(shortLocaleString)(history.value[0].created_at)
          }, {
            custom: _withCtx(() => [
              _createTextVNode("Eintrag erstellt")
            ]),
            _: 1
          }, 8, ["change-by", "change-time"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["is-visible"]))
}
}

})